import { ProductCarouselProps } from './ProductCarousel';

export const parseProductCarouselData = (
  // We need to consolidate the types from Homepage Section and PDP section.
  contentfulSection: any,
  advertisedPromos?: any,
): ProductCarouselProps | null => {
  if (!contentfulSection) {
    return null;
  }

  const { title, ctas } = contentfulSection.metadata || {};

  const { eyebrow, subsections } = contentfulSection;

  const cta = ctas && ctas.length ? ctas[0] : null;
  const parsedCTA = {
    label: cta?.label || '',
    url: cta?.url || '',
  };

  const productList =
    subsections && subsections.length
      ? (subsections as ReadonlyArray<{ items: any }>)[0]?.items
      : [];
  const productSlugs = productList.map(
    (product: any) => product.content.subsections[0].slug,
  );

  const productCarouselData: ProductCarouselProps = {
    title: title,
    eyebrow: eyebrow,
    cta: parsedCTA,
    productSlugs: productSlugs,
    advertisedPromos: advertisedPromos || [],
  };

  return productCarouselData;
};
